﻿$.fn.dxCtrlContentEnvoiMailingA = function custom_dxCtrlContentEnvoiMailingA(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentenvoimailinga dx-ctrl");
        this.createInstance(new cdxCtrlContentEnvoiMailingA(this, option));
    }
    return this;
}

window.cdxCtrlContentEnvoiMailingA = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var jauge = null
    var $DivTagBox = null
    var dxTagBoxDest = null
    var $DivDetailDest = null
    var $DivDetailDestInner = null
    var jaugeDetailDest = null
    function mConstruit() {
        container.empty()
        container.css("height", "200px")
        if (option.jauge == null) {
            jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        } else { jauge = option.jauge }
        jauge.mShow()
        window.setTimeout(function () {
            $DivTagBox = $("<div style=''/>").appendTo(container)
            $DivDetailDest = $("<div style='margin:10px 40px 0 40px;font-style:italic;'/>").appendTo(container)
            jaugeDetailDest = $("<div/>").appendTo($DivDetailDest).dxCtrlJauge({ height: 30, width: 30 }).dxCtrlJauge("instance")
            $DivDetailDestInner = $("<div style='width:100%;'/>").appendTo($DivDetailDest)
            mConstruitDestinataire()
            mConstruitDetailDest()
            container.css("height", "")
        }, 100)

    }

    function mConstruitDestinataire() {
        $DivTagBox.empty()

        var $Table = $("<table style='width:100%;'/>").appendTo($DivTagBox)
        var $Tr = $("<tr/>").appendTo($Table)
        //var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        //$("<div/>").appendTo($Td).dxCtrlButton({
        //    icon: "fas fa-xmark",
        //    onClick: function (e) {
        //        jauge.mShow()
        //        var obj = option.bddCtrl.getObjet(option.data)
        //        option.bddCtrl.mAjaxCall({
        //            command: "deldestinatairecom",
        //            id_table_com: obj.mGetTable().id_table,
        //            id_com: obj.cle()
        //        }, function (data) {
        //            option.data.dmo = parametre.dateNow
        //            obj.mSaveChamp("dcr") //pour mettre à jour la dmo
        //            option.clComDest.mSetLstDestCom([])
        //            mConstruit()
        //            option.onChange()
        //            jauge.mHide()
        //        })
        //    }
        //})
        var $Td = $("<td style='width:100%'></td>").appendTo($Tr)
        var lstIdTable = option.bddCtrl.table.mGetItemFromNom("structures").id_table + "," + option.bddCtrl.table.mGetItemFromNom("structures_contact").id_table + "," + option.bddCtrl.table.mGetItemFromNom("contact").id_table + "," + option.bddCtrl.table.mGetItemFromNom("dossier").id_table
        dxTagBoxDest = $("<div/>").appendTo($Td).dxCtrlTagBoxDestinataireCom({
            bddCtrl: option.bddCtrl,
            maxHeight: 200,
            type: option.type,
            lst_id_table: lstIdTable,
            items: option.clComDest.mGetLstDestCom(),
            jauge: jauge,
            showOpenList: true,
            getTotalItems: function () {
                return dxTagBoxDest.option("items")
            },
            data: option.data,
            id_type_destinataire: 1,
            onItemClickTag: function (itemData, items, funcEnd, itemEle) {
                if (itemData.deleteAll) {
                    $("<div/>").appendTo(container).dxCtrlLstBoxDestinataireSelect({
                        bddCtrl: option.bddCtrl,
                        dataSource: items,
                        title: "Liste des destinataires A:",
                        readOnly: false,
                        data: option.data,
                        type: "email",
                        maxWidthItem: "100%",
                        onDeleteAll: dxTagBoxDest.mDeleteAll,
                        onDeleteItem: dxTagBoxDest.mDeleteItem,
                        onItemClickTag: function (itemData, target, funcEnd, openFiche) {
                            var objDest = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(itemData.id_table_destinataire).nom, itemData.id_destinataire)
                            objDest.mShowPopup()
                        }
                    })
                } else {
                    if (itemData.id_table_destinataire == null) {
                        //on a pas de fiche, c'est un destinataire sans fiche (juste adresse email)
                        option.bddCtrl.getObjet("com_destinataire").objetMetier.mCreateContactFromComDest(itemEle, itemData, funcEnd, false)
                    } else {
                        var objDest = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(itemData.id_table_destinataire).nom, itemData.id_destinataire)
                        objDest.mShowPopup()
                    }
                }
            },
            onChange: function (e) {
                console.log("change dest A")
                var obj = option.bddCtrl.getObjet(option.data)
                //if (option.clComDest.mGetLstDestCom() > 1000) jaugeDemarrage.mShow()
                var timeOutJauge = window.setTimeout(function () { jaugeDemarrage.mShow() }, 1000)
                option.bddCtrl.mAjaxCall({ command: "getlstdestcomforgestion", id_table_com: obj.mGetTable().id_table, id_com: obj.cle(), type: option.type, async: false }, function (data) {
                    if (typeof data.lst_com_destinataire == 'undefined') data.lst_com_destinataire = []
                    option.clComDest.mSetLstDestCom(data.lst_com_destinataire)
                    mConstruitDetailDest()
                    option.onChange()
                    jaugeDemarrage.mHide()
                }, function () {
                    window.clearTimeout(timeOutJauge)
                })
            }
        }).dxCtrlTagBoxDestinataireCom("instance")
    }

    function mConstruitDetailDest() {
        $DivDetailDestInner.empty()

        if (option.clComDest.mGetLstDestCom().length > 0) {
            $("<div><b style='font-size:200%;'>" + option.clComDest.mGetLstDestCom().length + "</b> destinataires.</div>").appendTo($DivDetailDestInner)
        }

        var $DivDetail = $("<div style='opacity:0.8;padding:0 0px;font-size:90%;'/>").appendTo($DivDetailDestInner)

        if (option.clComDest.mGetLstIdentique().length == 0 && option.clComDest.mGetLstSansAdresse().length == 0 && option.clComDest.mGetLstListeNoire().length == 0 &&
            option.clComDest.mGetLstIndirect().length == 0 && option.clComDest.mGetLstDoublon().length == 0 &&
            option.clComDest.mGetLstHardBounce().length == 0 && option.clComDest.mGetLstSoftBounce().length == 0) {
            if (option.clComDest.mGetLstDestCom().length == 0) {
                $("<div style=''>(Aucun destinataire)</div>").appendTo($DivDetail)
            } else {
                $("<div style=''>Tous vos destinataires sont cohérents</div>").appendTo($DivDetail)
            }
        } else {
            var typeData = ((option.type == "email") ? "comdestgestemail" : ((option.type == "sms") ? "comdestgestsms" : "comdestgestcourrier"))

            //destinataire sans adresse
            if (option.clComDest.mGetLstSansAdresse().length > 0) {
                var $DivSansAdresse = $("<div/>").appendTo($DivDetail)
                $("<span>→ <b style='font-size:150%;'>" + option.clComDest.mGetLstSansAdresse().length + "</b> sans " + ((option.type == "email") ? "adresse email" : "téléphone mobile") + "</span>").appendTo($DivSansAdresse)
                var $aNettoie = $("<a href='javascript:void(0)' style='margin-left:5px;'><i class='fas fa-broom'></i>Nettoyer</a>").appendTo($DivSansAdresse)
                $aNettoie.attr("title", "Supprimer tous les destinataires<br/>sans " + ((option.type == "email") ? "adresse email" : "téléphone mobile"))
                $aNettoie.on("click", function (e) {
                    jauge.mShow()
                    window.setTimeout(function () {
                        var lstToDel = option.clComDest.mNettoieSansAdresse()
                        option.clComDest.mSaveDel(lstToDel, function () {
                            mConstruit()
                            option.bddCtrl.triggerFunctionOnModifiedItemData("com_email_envoi", "modif", option.data)
                            option.onChange()
                        })
                    }, 0)
                })
                var $aAfficheListe = $("<a href='javascript:void(0)' style='margin-left:15px;'><i class='fas fa-bars-staggered'></i>Afficher liste des sans adresse</a>").appendTo($DivSansAdresse)
                $aAfficheListe.attr("title", "Afficher la liste des destinataires sans adresse")
                $aAfficheListe.on("click", function (e) {
                    var lstIdTableId = []
                    option.clComDest.mGetLstSansAdresse().forEach(function (o) {
                        if (o.id_table_destinataire != null) lstIdTableId.push({ id_table: o.id_table_destinataire, id: o.id_destinataire })
                    })
                    if (lstIdTableId.length > 0) {
                        page.mAddPopupLst("Liste des destinataires sans adresse", function (contentElement) {
                            $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                bddCtrl: option.bddCtrl,
                                lstIdTableIdInclu: lstIdTableId
                            })
                        })
                    } else { mNotify("Aucune fiche afficher", "warning", 6000) }
                })
                //if (option.allowModifDest) {
                //    var $aModif = $("<a href='javascript:void(0)' style='margin-left:5px;'>Modifier</a>").appendTo($DivSansAdresse)
                //    $aModif.attr("title", "Saisir " + ((option.type == "email") ? "une adresse email" : "un téléphone mobile") + "<br/>pour les destinataires sans " + ((option.type == "email") ? "adresse email" : "téléphone mobile"))
                //    $aModif.on("click", function (e) {
                //        mShowList(typeData, "sansadresse", option.clComDest.mGetLstSansAdresse(), false,
                //            "Correction des destinataires sans " + ((option.type == "email") ? "adresse email" : "numéro de mobile"),
                //            "Supprimer les destinataires sans " + ((option.type == "email") ? "adresse" : "téléphone") + " ou saisissez " + ((option.type == "email") ? "une adresse email" : "un téléphone mobile"),
                //            "Aucun destinataire sans " + ((option.type == "email") ? "adresse email" : "sans téléphone"),
                //            "Ce destinataire ne dispose pas " + ((option.type == "email") ? "d'adresse email, saisissez en une..." : "de téléphone mobile, saisissez en un..."))
                //    })
                //}
            }

            //destinataire listeNoire
            if (option.clComDest.mGetLstListeNoire().length > 0) {
                var $DivListeNoire = $("<div/>").appendTo($DivDetail)
                $("<span>→ <b style='font-size:150%;'>" + option.clComDest.mGetLstListeNoire().length + "</b> désinscrits</span>").appendTo($DivListeNoire)
                var $aNettoie = $("<a href='javascript:void(0)' style='margin-left:5px;'><i class='fas fa-broom'></i>Nettoyer</a>").appendTo($DivListeNoire)
                $aNettoie.attr("title", "Supprimer tous les destinataires<br/>en désinscriptions")
                $aNettoie.on("click", function (e) {
                    jauge.mShow()
                    window.setTimeout(function () {
                        var lstToDel = option.clComDest.mNettoieListeNoire()
                        option.clComDest.mSetGardeListeNoire(false)
                        option.clComDest.mSaveDel(lstToDel, function () {
                            mConstruit()
                            option.bddCtrl.triggerFunctionOnModifiedItemData("com_email_envoi", "modif", option.data)
                            option.onChange()
                        })
                    }, 0)
                })

                var $aAfficheListe = $("<a href='javascript:void(0)' style='margin-left:15px;'><i class='fas fa-bars-staggered'></i>Afficher désinscriptions</a>").appendTo($DivListeNoire)
                $aAfficheListe.attr("title", "Afficher les désinscriptions")
                $aAfficheListe.on("click", function (e) {
                    var lstIdTableId = []
                    option.clComDest.mGetLstListeNoire().forEach(function (o) {
                        if (o.id_table_destinataire != null) lstIdTableId.push({ id_table: o.id_table_destinataire, id: o.id_destinataire })
                    })
                    if (lstIdTableId.length > 0) {
                        page.mAddPopupLst("Désinscriptions", function (contentElement) {
                            $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                bddCtrl: option.bddCtrl,
                                lstIdTableIdInclu: lstIdTableId
                            })
                        })
                    } else { mNotify("Aucune fiche afficher", "warning", 6000) }
                })
                var checkTrueConfirm = false
                var disableOnValueChanged = false
                $("<span style='margin-left:10px;' title='Si vous cochez cette case, les destinataires désinscrits ne seront pas automatiquement supprimé de votre liste et ces correspondants recevront votre message.'/>").appendTo($DivListeNoire).dxCtrlCheckBox({
                    text: "Garder les désinscriptions",
                    value: option.clComDest.mGetGardeListeNoire(),
                    onValueChanged: function (e) {
                        if (disableOnValueChanged) return;
                        if (e.value && !checkTrueConfirm) {
                            disableOnValueChanged = true
                            e.component.option("value", false)
                            disableOnValueChanged = false
                            var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                target: e.component.element(),
                                width: 300,
                                contentTemplate: function (contentElement) {
                                    contentElement.css("padding", "25px")
                                    contentElement.css("white-space", "normal")
                                    $("<div style='padding-bottom:15px;'>En cochant cette case, vous indiquez que vos destinataires en désinscriptions ne seront pas supprimés automatiquement.</div>").appendTo(contentElement)
                                    $("<div style='color:red;padding-bottom:15px;'>(Assurez vous bien que votre message est conforme pour vous autoriser à forcer l'envoi des destinataires désinscrits. En cas de plainte, votre compte pourra être suspendu)</div>").appendTo(contentElement)
                                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                                        text: "Confirmez",
                                        onClick: function (ee) {
                                            checkTrueConfirm = true
                                            tt.hide()
                                            e.component.option("value", true)
                                        }
                                    })
                                }
                            }).dxCtrlTooltip("instance")
                            tt.show()
                            return
                        }
                        checkTrueConfirm = false
                        option.clComDest.mSetGardeListeNoire(e.value)
                        jaugeDemarrage.mShow()
                        window.setTimeout(function () {
                            mConstruitDetailDest()
                            jaugeDemarrage.mHide()
                        }, 50)
                    },
                    onContentReady: function (e) {
                        e.component.element().find(".dx-checkbox-text").css("font-size", "80%")
                    }
                })
            }

            //destinataire identique
            if (option.clComDest.mGetLstIdentique().length > 0) {
                var $DivIdentique = $("<div/>").appendTo($DivDetail)
                var $Span = $("<span>→ <b style='font-size:150%;'>" + option.clComDest.mGetLstIdentique().length + "</b> identiques</span>").appendTo($DivIdentique)
                $Span.attr("title", "Des contacts sont spécifiés plusieurs fois dans la liste de vos destinataires<br/>A l'envoi, ces destinataires sont automatiquement nettoyé pour n'en garder qu'un seul par destinataire identique.")
                var $aNettoie = $("<a href='javascript:void(0)' style='margin-left:5px;'><i class='fas fa-broom'></i>Nettoyer</a>").appendTo($DivIdentique)
                $aNettoie.attr("title", "Garder un seul destinataire<br/>par destinataire identique")
                $aNettoie.on("click", function (e) {
                    jauge.mShow()
                    window.setTimeout(function () {
                        var lstToDel = option.clComDest.mNettoieIdentique()
                        option.clComDest.mSaveDel(lstToDel, function () {
                            mConstruit()
                            option.bddCtrl.triggerFunctionOnModifiedItemData("com_email_envoi", "modif", option.data)
                            option.onChange()
                        })
                    }, 0)
                })
            }

            //Destinataire indirect
            if (option.clComDest.mGetLstIndirect().length > 0) {
                var $DivIndirect = $("<div/>").appendTo($DivDetail)
                var $Span = $("<span>→ <b style='font-size:150%;'>" + option.clComDest.mGetLstIndirect().length + "</b> indirects</span>").appendTo($DivIndirect)
                $Span.attr("title", "Vous écrivez à un contact qui ne dispose pas d'adresse email direct. Vous écrivez à ce contact via l'adresse email de sa structure.")
                var $aNettoie = $("<a href='javascript:void(0)' style='margin-left:5px;'><i class='fas fa-broom'></i>Nettoyer</a>").appendTo($DivIndirect)
                $aNettoie.attr("title", "Supprimer les destinataires indirectes")
                $aNettoie.on("click", function (e) {
                    jaugeDemarrage.mShow()
                    window.setTimeout(function () {
                        var lstToDel = option.clComDest.mNettoieIndirect()
                        option.clComDest.mSaveDel(lstToDel, function () {
                            mConstruit()
                            option.bddCtrl.triggerFunctionOnModifiedItemData("com_email_envoi", "modif", option.data)
                            option.onChange()
                            jaugeDemarrage.mHide()
                        })
                    }, 0)
                })
                var $aAfficheListe = $("<a href='javascript:void(0)' style='margin-left:15px;'><i class='fas fa-bars-staggered'></i>Afficher liste emails indirects</a>").appendTo($DivIndirect)
                $aAfficheListe.attr("title", "Afficher la liste des emails indirects")
                $aAfficheListe.on("click", function (e) {
                    var lstIdTableId = []
                    option.clComDest.mGetLstIndirect().forEach(function (o) {
                        if (o.id_table_destinataire != null) lstIdTableId.push({ id_table: o.id_table_destinataire, id: o.id_destinataire })
                    })
                    if (lstIdTableId.length > 0) {
                        page.mAddPopupLst("Liste des emails indirects", function (contentElement) {
                            $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                bddCtrl: option.bddCtrl,
                                lstIdTableIdInclu: lstIdTableId
                            })
                        })
                    } else { mNotify("Aucune fiche afficher", "warning", 6000) }
                })
                //if (option.allowModifDest) {
                //    var $aModif = $("<a href='javascript:void(0)' style='margin-left:5px;'>Modifier</a>").appendTo($DivIndirect)
                //    $aModif.attr("title", "Saisir une adresse email<br/>pour les destinataires indirectes")
                //    $aModif.on("click", function (e) {
                //        mShowList(typeData, "indirect", option.clComDest.mGetLstIndirect(), false,
                //            "Saisie " + ((option.type == "email") ? "d'un email" : "d'un numéro de mobile") + " pour les destinataires indirectes",
                //            "Actuellement, ces destinataires recoivent un " + ((option.type == "email") ? "email" : "sms") + " sur " + ((option.type == "email") ? "l'adresse email" : "le mobile") + " définie sur leur structure car ils n'ont pas " + ((option.type == "email") ? "d'adresse email" : "de numéro de mobile") + " directe saisie.",
                //            "Aucun destinataire indirecte",
                //            "Ce contact a " + ((option.type == "email") ? "une adresse email indirecte (celle de sa structure), saisissez en une directe pour lui dans la structures..." : "un téléphone mobile indirecte (celui de la structure), saisissez en un direct pour lui dans la structure..."))
                //    })
                //}
            }

            if (option.clComDest.mGetLstDoublon().length > 0) {
                var $DivDoublon = $("<div/>").appendTo($DivDetail)
                var $Span = $("<span>→ <b style='font-size:150%;'>" + option.clComDest.mGetLstDoublon().length + "</b> en doublon " + ((option.type == "email") ? "d'adresse email" : "de téléphone mobile") + ".</span>").appendTo($DivDoublon)
                $Span.attr("title", "A l'envoi, ces destinataires sont automatiquement nettoyés pour n'en garder qu'un seul par " + ((option.type == "email") ? "adresse email" : "numéro de téléphone") + " identique.")
                var $aNettoie = $("<a href='javascript:void(0)' style='margin-left:5px;'><i class='fas fa-broom'></i>Nettoyer</a>").appendTo($DivDoublon)
                $aNettoie.attr("title", "Supprimer les doublons<br/>en choisissant aux hasard un des doublons<br/>et en supprimant les autres destinataires")
                $aNettoie.on("click", function (e) {
                    jaugeDemarrage.mShow()
                    window.setTimeout(function () {
                        var lstToDel = option.clComDest.mNettoieDoublon()
                        option.clComDest.mSaveDel(lstToDel, function () {
                            mConstruit()
                            option.bddCtrl.triggerFunctionOnModifiedItemData("com_email_envoi", "modif", option.data)
                            option.onChange()
                            jaugeDemarrage.mHide()
                        })
                    }, 0)
                })
                var $aAfficheListe = $("<a href='javascript:void(0)' style='margin-left:15px;'><i class='fas fa-bars-staggered'></i>Afficher liste des doublons</a>").appendTo($DivDoublon)
                $aAfficheListe.attr("title", "Afficher la liste des doublons")
                $aAfficheListe.on("click", function (e) {
                    var lstIdTableId = []
                    option.clComDest.mGetLstDoublon().forEach(function (o) {
                        if (o.id_table_destinataire != null) lstIdTableId.push({ id_table: o.id_table_destinataire, id: o.id_destinataire })
                    })
                    if (lstIdTableId.length > 0) {
                        page.mAddPopupLst("Liste des doublons d'emails", function (contentElement) {
                            $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                bddCtrl: option.bddCtrl,
                                lstIdTableIdInclu: lstIdTableId
                            })
                        })
                    } else { mNotify("Aucune fiche afficher", "warning", 6000) }
                })
                //if (option.allowModifDest) {
                //    var $aModif = $("<a href='javascript:void(0)' style='margin-left:5px;'>Modifier</a>").appendTo($DivDoublon)
                //    $aModif.attr("title", "Modifier " + ((option.type == "email") ? "l'adresse email" : "le téléphone mobile") + "<br/>pour les destinataires en doublon")
                //    $aModif.on("click", function (e) {
                //        mShowList(typeData, "doublon", option.clComDest.mGetLstDoublon(), true,
                //            "Correction des destinataires en doublon " + ((option.type == "email") ? "d'adresse email" : "de numéro de mobile"),
                //            "Supprimer les doublons ou modifier leur " + ((option.type == "email") ? "adresse email" : "téléphone mobile"),
                //            "Aucun destinataire en doublon " + ((option.type == "email") ? "d'adresse email" : "de mobile"),
                //            "Ce destinataire à " + ((option.type == "email") ? "une adresse email en doublon, saisissez une autre adresse pour le destinataire..." : "un téléphone mobile en doublon, saisissez un autre numéro pour le contact..."))
                //    })
                //}
            }

            //hard bounce
            if (option.clComDest.mGetLstHardBounce().length > 0) {
                var $DivHardBounce = $("<div/>").appendTo($DivDetail)
                var $Span = $("<span>→ <b style='font-size:150%;'>" + option.clComDest.mGetLstHardBounce().length + "</b> en hard-bounce.</span>").appendTo($DivHardBounce)
                $Span.attr("title", "Destinataires en hard-bounce</b><br/><i style='font-size:80%;'>Vous ne pouvez pas envoyer d'email sur ces adresses dans le cadre d'un emailing. Ces destinataires seront automatiquement retirer de votre emailing.")
                var $aNettoie = $("<a href='javascript:void(0)' style='margin-left:5px;'><i class='fas fa-broom'></i>Nettoyer</a>").appendTo($DivHardBounce)
                $aNettoie.on("click", function (e) {
                    jaugeDemarrage.mShow()
                    window.setTimeout(function () {
                        var lstToDel = option.clComDest.mNettoieHardBounce()
                        option.clComDest.mSaveDel(lstToDel, function () {
                            mConstruit()
                            option.bddCtrl.triggerFunctionOnModifiedItemData("com_email_envoi", "modif", option.data)
                            option.onChange()
                            jaugeDemarrage.mHide()
                        })
                    }, 0)
                })
                var $aAfficheListe = $("<a href='javascript:void(0)' style='margin-left:15px;'><i class='fas fa-bars-staggered'></i>Afficher liste bounces</a>").appendTo($DivHardBounce)
                $aAfficheListe.attr("title", "Afficher la liste des bounces")
                $aAfficheListe.on("click", function (e) {
                    var lstIdTableId = []
                    option.clComDest.mGetLstHardBounce().forEach(function (o) {
                        if (o.id_table_destinataire != null) lstIdTableId.push({ id_table: o.id_table_destinataire, id: o.id_destinataire })
                    })
                    if (lstIdTableId.length > 0) {
                        page.mAddPopupLst("Liste des bounces d'emails", function (contentElement) {
                            $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                bddCtrl: option.bddCtrl,
                                lstIdTableIdInclu: lstIdTableId
                            })
                        })
                    } else { mNotify("Aucune fiche afficher", "warning", 6000) }
                })
                //if (option.allowModifDest) {
                //    var $aModif = $("<a href='javascript:void(0)' style='margin-left:5px;'>Modifier</a>").appendTo($DivHardBounce)
                //    $aModif.attr("title", "Modifier " + ((option.type == "email") ? "les adresses emails" : "les numéros de téléphones mobiles") + "<br/>qui sont en hard-bounce")
                //    $aModif.on("click", function (e) {
                //        mShowList(typeData, "hardbounce", option.clComDest.mGetLstHardBounce(), false,
                //            "Corriger les adresse en hard-bounce",
                //            "Vous pouvez supprimer le destinataire ou modifier son adresse email en hard-bounce (qui n'existe pas)",
                //            "Aucun destinataire en hard-bounce",
                //            "Ce destinataire à " + ((option.type == "email") ? "une adresse email en hard-bounce, saisissez une autre adresse pour le destinataire..." : "un téléphone mobile en hard-bounce, saisissez un autre numéro pour le contact..."))
                //    })
                //}
            }

            //soft bounce
            if (option.clComDest.mGetLstSoftBounce().length > 0) {
                var $DivSoftBounce = $("<div/>").appendTo($DivDetail)
                var $Span = $("<span>→ <b style='font-size:150%;'>" + option.clComDest.mGetLstSoftBounce().length + "</b> en soft-bounce.</span>").appendTo($DivSoftBounce)
                $Span.attr("title", "Destinataires en hard-bounce</b><br/><i style='font-size:80%;'>Vous ne pouvez pas envoyer d'email sur ces adresses dans le cadre d'un emailing. Ces destinataires seront automatiquement retirer de votre emailing.")
                var $aNettoie = $("<a href='javascript:void(0)' style='margin-left:5px;'><i class='fas fa-broom'></i>Nettoyer</a>").appendTo($DivSoftBounce)
                $aNettoie.on("click", function (e) {
                    jauge.mShow()
                    window.setTimeout(function () {
                        jaugeDemarrage.mShow()
                        var lstToDel = option.clComDest.mNettoieSoftBounce()
                        option.clComDest.mSaveDel(lstToDel, function () {
                            mConstruit()
                            option.bddCtrl.triggerFunctionOnModifiedItemData("com_email_envoi", "modif", option.data)
                            option.onChange()
                            jaugeDemarrage.mHide()
                        })
                    }, 0)
                })
                //if (option.allowModifDest) {
                //    var $aModif = $("<a href='javascript:void(0)' style='margin-left:5px;'>Modifier</a>").appendTo($DivHardBounce)
                //    $aModif.attr("title", "Modifier " + ((option.type == "email") ? "les adresses emails" : "les numéros de téléphones mobiles") + "<br/>qui sont en soft-bounce")
                //    $aModif.on("click", function (e) {
                //        mShowList(typeData, "softbounce", option.clComDest.mGetLstSoftBounce(), false,
                //            "Corriger les adresse en soft-bounce",
                //            "Vous pouvez supprimer le destinataire ou modifier son adresse email en soft-bounce (adresse inopérante)",
                //            "Aucun destinataire en soft-bounce",
                //            "Ce destinataire à " + ((option.type == "email") ? "une adresse email en soft-bounce, saisissez une autre adresse pour le destinataire..." : "un téléphone mobile en soft-bounce, saisissez un autre numéro pour le contact..."))
                //    })
                //}
            }

            if (option.clComDest.mGetLstDestCom().length != option.clComDest.mGetLstDestComNettoyer().length) {
                $("<div><b style='font-size:200%;'>" + ((option.clComDest.mGetLstDestComNettoyer().length == 0) ? "Aucun" : option.clComDest.mGetLstDestComNettoyer().length) + "</b> destinataire" + ((option.clComDest.mGetLstDestComNettoyer().length > 1) ? "s" : "") + " aprés nettoyage des destinataires désinscrits, en bounce, sans " + ((option.type == "email") ? "adresse email" : "numéro mobile") + " et en doublon. </div>").appendTo($DivDetailDestInner)
            } else {
                $("<div style=''>Tous vos destinataires sont cohérents</div>").appendTo($DivDetail)
            }

            var $aNettoieTout = null
            if (option.clComDest.mGetLstDoublon().length > 0 ||
                option.clComDest.mGetLstIdentique().length > 0 || option.clComDest.mGetLstSansAdresse().length > 0 ||
                option.clComDest.mGetLstHardBounce().length > 0 || option.clComDest.mGetLstSoftBounce().length > 0) {
                $aNettoieTout = $("<a href='javascript:void(0)'><i class='fas fa-broom'></i>Nettoyer tout</a>").appendTo($DivDetailDestInner)
                $aNettoieTout.attr("title", "Supprime automatiquement tous les destinataires<br/>qui ne peuvent recevoir votre message")
                $aNettoieTout.on("click", function (e) {
                    jaugeDemarrage.mShow()
                    window.setTimeout(function () {
                        var lstToDel = option.clComDest.mNettoieListeNoireETIdentiqueETDoublonETSansAdresseETHardBounce()
                        option.clComDest.mSaveDel(lstToDel, function () {
                            mConstruit()
                            option.bddCtrl.triggerFunctionOnModifiedItemData("com_email_envoi", "modif", option.data)
                            option.onChange()
                            jaugeDemarrage.mHide()
                        })
                    }, 0)
                })
            }
            if (option.clComDest.mGetLstIndirect().length > 0 || option.clComDest.mGetLstDoublon().length > 0 ||
                option.clComDest.mGetLstIdentique().length > 0 || option.clComDest.mGetLstSansAdresse().length > 0 ||
                option.clComDest.mGetLstHardBounce().length > 0 || option.clComDest.mGetLstSoftBounce().length > 0) {
                var $aRecalculTout = $("<a href='javascript:void(0)'><i class='fas fa-rotate'></i>Tout recalculer</a>").appendTo($DivDetailDestInner)
                if ($aNettoieTout) $aRecalculTout.css("margin-left", "15px")
                $aRecalculTout.attr("title", "Si vous avez modifier vos destinataires (via les fiches), vous pouvez recalculer la cohérence de vos destinataires.")
                $aRecalculTout.on("click", function (e) {
                    jaugeDemarrage.mShow()
                    var obj = option.bddCtrl.getObjet(option.data)
                    option.bddCtrl.mAjaxCall({
                        command: "updatedestcomfromcom",
                        id_table_com: obj.mGetTable().id_table,
                        id_com: obj.cle(),
                        type: option.type
                    }, function (data) {
                        if (typeof data.lst_com_destinataire == 'undefined') data.lst_com_destinataire = []
                        option.clComDest = new cComDest(option.bddCtrl, data.lst_com_destinataire)
                        mConstruit()
                        option.bddCtrl.triggerFunctionOnModifiedItemData("com_email_envoi", "modif", option.data)
                        option.onChange()
                        jaugeDemarrage.mHide()
                    })
                })

            }

        }

        var $aAjoutDestEmail = $("<a href='javascript:void(0)'><i class='fas fa-square-envelope'></i> Ajouter/enlever destinataire d'un email envoyé</a>").appendTo($DivDetailDestInner)
        $aAjoutDestEmail.css("margin-left", "15px")
        $aAjoutDestEmail.attr("title", "Ajouter ou enlever les destinataires d'un email existant (tous ou seulement destinataire annulé, en erreur, vue, click...).")
        $aAjoutDestEmail.on("click", function (e) {
            var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
                position: {
                    my: "right top",
                    at: "right top",
                    of: "body"
                },
                hideOnOutsideClick: true,
                width: 650,
                height: "100%",
                showTitle: true,
                showMaximize: false,
                title: "Sélectionner un mailing",
                contentTemplate: function (contentElement) {
                    var opt = {
                        bddCtrl: option.bddCtrl,
                        context_grid: "email_envoi_choix",
                        lstIdTypeClassement: [],
                        //adresse_email: itemDataCompteEmail.adresse_email, //Favori ou adresse_email
                    }
                    opt.lstLstConditionBase = [[{ nom_champ: "presentation_mailing", ope: "ismailing" }]]
                    opt.onClickDataGrid = function (container, dataGrid, dataTemplate) {
                        pop.hide()
                        $("<div/>").appendTo("body").dxCtrlPopupSelectDestinataireMailing({
                            bddCtrl: option.bddCtrl,
                            id: dataGrid.id,
                            showAddRemove:true,
                            onValide: function (lstIdTableId,selectRetire) {
                                switch (selectRetire) {
                                    case "Ajouter les destinataires":
                                        var lstDataSimple = []
                                        lstIdTableId.forEach(function (itemData) {
                                            lstDataSimple.push({ id_table: itemData.id_table_destinataire, id: itemData.id_destinataire })
                                        })
                                        var obj = option.bddCtrl.getObjet(option.data)
                                        jaugeDemarrage.mShow()
                                        option.bddCtrl.mAjaxCall({
                                            command: "addnewdestcom",
                                            lstnewdestcom: lstDataSimple,
                                            id_table_com: obj.mGetTable().id_table,
                                            id_com: obj.cle(),
                                            id_type_destinataire: 1,
                                            type: option.type
                                        }, function (data) {
                                            //var timeOutJauge = window.setTimeout(function () { jaugeDemarrage.mShow() }, 1000)
                                            option.bddCtrl.mAjaxCall({ command: "getlstdestcomforgestion", id_table_com: obj.mGetTable().id_table, id_com: obj.cle(), type: option.type, async: false }, function (data) {
                                                if (typeof data.lst_com_destinataire == 'undefined') data.lst_com_destinataire = []
                                                option.clComDest.mSetLstDestCom(data.lst_com_destinataire)
                                                option.onChange()
                                                mConstruit()
                                                jaugeDemarrage.mHide()
                                            }, function () {
                                            })
                                        })
                                        break;
                                    case "Retirer les destinataires":
                                        jaugeDemarrage.mShow()
                                        var lstToDel = option.clComDest.mNettoieFromListIdTableId(lstIdTableId)
                                        option.clComDest.mSaveDel(lstToDel, function () {
                                            var obj = option.bddCtrl.getObjet(option.data)
                                            option.bddCtrl.mAjaxCall({ command: "getlstdestcomforgestion", id_table_com: obj.mGetTable().id_table, id_com: obj.cle(), type: option.type, async: false }, function (data) {
                                                if (typeof data.lst_com_destinataire == 'undefined') data.lst_com_destinataire = []
                                                option.clComDest.mSetLstDestCom(data.lst_com_destinataire)
                                                option.onChange()
                                                mConstruit()
                                                jaugeDemarrage.mHide()
                                            }, function () {
                                            })
                                        })
                                        break;
                                }
                            }
                        })
                    }
                    $("<div/>").appendTo(contentElement).dxCtrlGridEmailEnvoi(opt)
                }
            }).dxCtrlPopupBase("instance")
            pop.show()
        })
        jauge.mHide()
    }

    //function mShowList(typeData, typeGest, lstIdTableIdInclu, isDoublon, title, sstitle, noDataText, placeholder) {
    //    var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
    //        fullScreen: false,
    //        showTitle: true,
    //        title: title,
    //        width: 800,
    //        position: {
    //            my: "right top",
    //            at: "right top",
    //            of: "body"
    //        },
    //        showMinimize: false,
    //        resizeEnabled: false,
    //        draggingEnabled: false,
    //        shading: true,
    //        contentTemplate: function (contentElement) {
    //            var newLstIdTableIdInclu = []
    //            var idTabComDest = option.bddCtrl.table.mGetItemFromNom("com_destinataire").id_table
    //            lstIdTableIdInclu.forEach(function (data) { newLstIdTableIdInclu.push({ id_table: idTabComDest, id: data.id_com_destinataire }) })

    //            var $DivGrid = $("<div style='height:100%;'/>").appendTo(contentElement).
    //                dxCtrlGridGestionDestinataire({
    //                    bddCtrl: option.bddCtrl,
    //                    typeData: typeData,
    //                    isDoublon: isDoublon,
    //                    context_grid: "gridgestdestcom_" + typeGest + "_" + typeData,
    //                    title: title,
    //                    ssTitle: sstitle,
    //                    noDataText: noDataText,
    //                    lstIdTableIdInclu: newLstIdTableIdInclu,
    //                    placeholder: placeholder
    //                })
    //        },
    //        onHiding: function () {
    //            jaugeDemarrage.mShow()
    //            var obj = option.bddCtrl.getObjet(option.data)
    //            option.bddCtrl.mAjaxCall({ command: "getlstdestcomforgestion", id_table_com: obj.mGetTable().id_table, id_com: obj.cle(), type: option.type }, function (data) {
    //                if (typeof data.lst_com_destinataire == 'undefined') data.lst_com_destinataire = []
    //                option.clComDest.mSetLstDestCom(data.lst_com_destinataire)
    //                option.onChange()
    //                jaugeDemarrage.mHide()
    //            })
    //        }
    //    }).dxCtrlPopupBase("instance")
    //    popup.show()
    //}

    this.element = function () { return container }

    mConstruit();
}